import React from 'react';
import { formatMDYWithParam } from 'utils/formatDate';
import { Tooltip, Typography } from 'antd';

const { Text } = Typography;

export const mapToRoleMemberGridColDef = (columns) => {
  let memberRoleGridColumns = [
    {
      field: '',
      checkboxSelection: true,
      filter: false,
      suppressHeaderMenuButton: true,
      width: 50,
      resizable: false,
    },
  ];
  const defaultConfig = {
    suppressHeaderMenuButton: true,
  };

  const hiddenCol = ['memberId'];

  if (columns?.length > 0) {
    columns.forEach((col) => {
      if (hiddenCol.indexOf(col.fieldNameCamelCase) === -1) {
        if (col.fieldNameCamelCase === 'dateAssigned') {
          col = { ...col, cellRenderer: formatMDYWithParam };
        } else {
          col = { ...col, width: 150 };
        }

        const nextCol = { ...defaultConfig, ...col };

        memberRoleGridColumns.push(nextCol);
      }
    });
  }

  return memberRoleGridColumns;
};

export const mapToMemberNotInRoleGridColDef = (columns) => {
  let memberRoleGridColumns = [
    {
      field: '',
      checkboxSelection: true,
      filter: false,
      suppressHeaderMenuButton: true,
      width: 50,
      resizable: false,
    },
  ];
  const defaultConfig = {
    suppressHeaderMenuButton: true,
  };

  const hiddenCol = ['memberId', 'dateAssigned'];

  if (columns?.length > 0) {
    columns.forEach((col) => {
      if (hiddenCol.indexOf(col.fieldNameCamelCase) === -1) {
        if (col.fieldNameCamelCase === 'dateAssigned') {
          col = { ...col, cellRenderer: formatMDYWithParam };
        } else if (col.fieldNameCamelCase === 'memberName') {
          col = { ...col, cellRenderer: MemberNameCellWithTooltip };
        } else {
          col = { ...col, width: 150 };
        }

        const nextCol = { ...defaultConfig, ...col };

        memberRoleGridColumns.push(nextCol);
      }
    });
  }

  return memberRoleGridColumns;
};

/**
 * ! SUB COMPONENT
 * @param {*} params
 * @returns
 */
const MemberNameCellWithTooltip = (params) => {
  return (
    <Tooltip
      placement='topLeft'
      title={params.value}
      mouseEnterDelay={0.3}
      mouseLeaveDelay={0}
    >
      <Text ellipsis>{params.value}</Text>
    </Tooltip>
  );
};
